module.exports = __webpack_public_path__ + "static/media/SpeakerLow.3519f6bc.svg";